import React from 'react';
import {
  LayoutGrid,
  Zap,
  GraduationCap,
  Bot,
  Camera,
  Music,
  Gamepad2,
  MessageSquare,
  Film,
  CreditCard,
  Activity,
  ShoppingBag,
  Plane,
  Sparkles,
  Layers
} from 'lucide-react';

export interface CategoryIconProps {
  slug?: string;
  name?: string;
  className?: string;
  size?: number | string;
  strokeWidth?: number;
}

const CATEGORY_MAP: Record<string, React.ComponentType<{ className?: string; size?: number | string; strokeWidth?: number }>> = {
  all: LayoutGrid,
  'all categories': LayoutGrid,
  productivity: Zap,
  education: GraduationCap,
  ai: Bot,
  'ai & tools': Bot,
  'photo-video': Camera,
  'photo & video': Camera,
  music: Music,
  'music & audio': Music,
  games: Gamepad2,
  social: MessageSquare,
  entertainment: Film,
  finance: CreditCard,
  health: Activity,
  'health & fitness': Activity,
  shopping: ShoppingBag,
  travel: Plane
};

/**
 * Consistent System Category Icon (SF Symbols aesthetic)
 * Simple, monochrome, consistent proportions, thin/medium stroke (1.75), rounded geometry.
 */
export const CategoryIcon: React.FC<CategoryIconProps> = ({
  slug,
  name,
  className = 'w-4 h-4',
  size = 18,
  strokeWidth = 1.75
}) => {
  const key = (slug || name || '').toLowerCase().trim();
  const IconComponent = CATEGORY_MAP[key] || CATEGORY_MAP[key.replace(/\s+/g, '-')] || Sparkles;

  return <IconComponent className={className} size={size} strokeWidth={strokeWidth} />;
};

export default CategoryIcon;
